import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-06/task-03";

const task: Slide = {
  titleHtml:
    "A shoebox-shaped room with dimensions 18 m x 18 m x 9 m is finished with a material that yields the<br>average absorption coefficient in the room of 0.12. A directional source with the sound power of 0.1 W is<br>put inside. The source favors the frontal direction of radiation, for which the directivity factor is 5, whereas<br>the directivity factor for the back direction is equal to 0.5.<br>The direct sound pressure level in front of the source<br>at the distances of 1, 4 and 16 meters away from the source is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: [
        {
          variant: "__task__",
          data: {
            id: task03.id,
          },
        },
      ],
    },
  },
};

export default task;
